import { configureStore } from '@reduxjs/toolkit';
import paymentReducer from './slices/paymentSlice';
import authReducer from './slices/authSlice';

export const store = configureStore({
  reducer: {
    payment: paymentReducer,
    auth: authReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    })
}); 